module.exports = __webpack_public_path__ + "static/media/caret.2fc2f8f0.svg";